<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">      
      <vs-col class="h-5 w-3 mr-4 hover:text-primary">          
        {{params.value}}
      </vs-col>
      <feather-icon v-if="isReader" icon="ListIcon" class="mt-2" svgClasses="h-5 w-5 mr-4 mt-2 hover:text-primary cursor-pointer" @click="viewVersions" v-b-tooltip.hover :title="$t('MRMR.Statement.ViewVersionsTooltip')" />
    </div>
</template>

<script>
export default {
  name: 'StatementVersionsCellRenderer',
  computed: {
    isReader() {
      return this.$auth.isInRole("MRMRReaders") || this.$auth.isInRole("Admin");
    }
  },
  methods: {
    viewVersions () {
      this.params.context.componentParent.openVersionsPopup(this.params.data.id);
    }
  }
}
</script>
